import { render } from "./TarifSelect.vue?vue&type=template&id=06f8a9fa"
import script from "./TarifSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TarifSelect.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TarifSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06f8a9fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06f8a9fa', __exports__)) {
    api.reload('06f8a9fa', __exports__)
  }
  
  module.hot.accept("./TarifSelect.vue?vue&type=template&id=06f8a9fa", () => {
    api.rerender('06f8a9fa', render)
  })

}


export default __exports__